import { HStackTypes } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';

const baseContainerStyles: HStackTypes.Props = {
  space: 'inline.nano',
};

const withScrollContainerStyles: HStackTypes.Props = {
  ...baseContainerStyles,
  p: 'inset.xs',
  pb: 0,
  background: 'background',
  borderRadius: BoxBorder.thick,
  maxH: 280,
  overflowY: 'auto',
};

export const getContainerStyles = (withScrollableContainer: boolean): HStackTypes.Props => {
  if (withScrollableContainer) {
    return withScrollContainerStyles;
  }

  return baseContainerStyles;
};
